// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReadOutlinedSvg from "@ant-design/icons-svg/es/asn/ReadOutlined";
import AntdIcon from '../components/AntdIcon';

var ReadOutlined = function ReadOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReadOutlinedSvg
  }));
};

ReadOutlined.displayName = 'ReadOutlined';
export default React.forwardRef(ReadOutlined);